import { memo } from "react";

import { MarketingPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickIconFilled from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { useMatch } from "react-router-dom";

export type RecoverSubRoute = "conversation-log" | "welcome";

export const RecoverItems = memo(function RecoverItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const settings = team.settings;
  const canViewMarketingAnalytics = useHasPermission(
    MarketingPermissions.VIEW_MARKETING_ANALYTICS,
  );

  const recoverRoot = routes.recoverHref;

  const recoverEnabled = settings.recover?.enabled;

  const anyChildSelected = useMatch(`${recoverRoot}/*`);

  const primaryHref = recoverEnabled
    ? routes.recoverHref
    : routes.getRecoverSubRoute("welcome");

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: primaryHref }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={CursorClickIconFilled}
      friendlyName="Recover"
      hidden={!canViewMarketingAnalytics}
      id="recover"
      UnfilledIcon={CursorClickIcon}
    >
      <RecoverConversationLogItem hidden={!recoverEnabled} />
      <RecoverWelcomeItem hidden={recoverEnabled} />
    </RedoSecondaryNavItem>
  );
});

const RecoverConversationLogItem = memo(function RecoverConversationLogItem({
  hidden,
}: {
  hidden?: boolean;
}) {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getRecoverSubRoute("conversation-log"),
      }}
      friendlyName="Conversation log"
      hidden={hidden}
      id="conversation-log"
    />
  );
});

const RecoverWelcomeItem = memo(function RecoverWelcomeItem({
  hidden,
}: {
  hidden?: boolean;
}) {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getRecoverSubRoute("welcome") }}
      friendlyName="Welcome"
      hidden={hidden}
      id="welcome"
    />
  );
});
